<template>
  <b-col cols="12">
    <b-form-group
      :label="`Text SMS: ${peopleDetail.contactPhone}`"
      class="my-2"
      label-for="inputSMS"
    >
      <b-form-textarea v-model="SMSText" id="inputSMS" rows="6" max-rows="6"/>
    </b-form-group>
    <b-row class="ml-1">
      Znaků: {{countSMS(SMSText).length}} &nbsp;&nbsp;&nbsp;&nbsp;
      Zústává: {{countSMS(SMSText).remaining}} &nbsp;&nbsp;&nbsp;&nbsp;
      Počet zpráv: {{countSMS(SMSText).messages}} &nbsp;&nbsp;&nbsp;&nbsp;
    </b-row>
    <b-row>
      <b-col cols="7">
        <b-form-checkbox v-model="flashSMS" class="mt-2" switch>Flash SMS</b-form-checkbox>
      </b-col>
      <b-col cols="5">
        <b-button class="btn-block" @click="sendSMS" size="sm" variant="success">Odeslat SMS</b-button>
      </b-col>
    </b-row>
  </b-col>
</template>

<script>
import Vue from 'vue'
import axios from 'axios'
import SmsCounter from 'sms-counter'

export default Vue.extend({
  props: {
    peopleDetail: null
  },
  data: () => ({
    SMSText: '',
    flashSMS: false
  }),

  methods: {
    countSMS (sendSMSMessage) {
      return SmsCounter.count(sendSMSMessage)
    },
    sendSMS () {
      axios
        .post(`/api/v1/sms/people`, { id: this.peopleDetail.id, text: this.SMSText, flash_sms: this.flashSMS })
        .then(response => {
          if (response.data.message === 'OK') {
            this.$bvToast.toast(`Odeslání proběhlo v pořádku`, {
              title: 'Odeslání SMS',
              variant: 'success',
              autoHideDelay: 1500
            })
            // this.$emit('closeSMS')
          }
        }) // message OK
        .catch(() => {
          this.$bvToast.toast(`Chyba při odesílání SMS`, {
            title: 'Odeslání SMS',
            variant: 'danger',
            autoHideDelay: 1500
          })
        })
    }
  }
})
</script>
